const B2C_COOKIE_PREFIXES = ["x-ms-cpim-", "x-ms-cpim-csrf", "x-ms-cpim-trans", "x-ms-cpim-dc"];

const expireCookie = (cookieName: string, domain?: string) => {
  const domainAttribute = domain ? ` domain=${domain};` : "";

  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;${domainAttribute}`;
};

export const clearB2CCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    const cookieName = cookie.split("=")[0].trim();
    const isB2CCookie = B2C_COOKIE_PREFIXES.some((prefix) => cookieName.includes(prefix));

    if (!isB2CCookie) return;

    expireCookie(cookieName);
    expireCookie(cookieName, window.location.hostname);
  });
};

export const clearBrowserStorage = () => {
  clearB2CCookies();
  sessionStorage.clear();
  localStorage.clear();
};
